export const SIGLA_SERVICO_PERICIA_INICIAL = 'PI';
export const SIGLA_SERVICO_AGENDAMENTO_PERICIA_INICIAL = 'APIPMF';
export const SIGLA_SERVICO_AGENDAMENTO_PERICIA_PMC = 'APMCPMF';
export const SIGLA_SERVICO_AGENDAMENTO_PERICIA_PMRES = 'APMRESPMF';
export const SIGLA_SERVICO_PERICIA_PEDIDO_PRORROGACAO = 'PMPP';
export const SIGLA_SERVICO_PERICIA_INICIAL_COM_ATESTADO = 'ADDMTAR';
export const SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO = 'DOCMTAR2';
export const SIGLA_SERVICO_PMF_TELEMEDICINA_BPC = 'ATELEPMBPC';
export const SIGLA_SERVICO_PMF_TELEPERICIA_PMF = 'ATELEPIPMF';
export const SIGLA_SERVICO_PMF_REAVALIACAO_TELEPERICIA = 'ATLREAVBPC';

export const SIGLA_SERVICO_CANCELAR_CTC = 'TCANCTC';
export const SIGLA_SERVICO_SOLICITAR_CTC = 'TCTC';
export const SIGLA_SERVICO_REVISAO_CTC = 'TREVCTC';

export const SIGLA_SERVICO_B87 = 'TBSBAPD';

export const SIGLA_SERVICO_AVALIACAO_SOCIAL_B87 = 'BSAS';
export const SIGLA_SERVICO_AVALIACAO_SOCIAL_B87_REMOTA = 'BSASREM';
export const SIGLA_SERVICO_AVALIACAO_SOCIAL_B87_PRIORITARIO = 'BSASP';
export const SIGLA_SERVICO_AVALIACAO_SOCIAL_B87_REMOTA_PRIORITARIO = 'BSASREMP';
export const SIGLAS_SERVICOS_AGENDAMENTO_B87 = [
  SIGLA_SERVICO_AVALIACAO_SOCIAL_B87,
  SIGLA_SERVICO_AVALIACAO_SOCIAL_B87_REMOTA,
  SIGLA_SERVICO_AVALIACAO_SOCIAL_B87_PRIORITARIO,
  SIGLA_SERVICO_AVALIACAO_SOCIAL_B87_REMOTA_PRIORITARIO
];
export const SIGLA_SERVICO_PMF_REAVALIACAO_TELEPERICIA_B87 = 'ATLREAVBPC';

export const SIGLA_SERVICO_PMF_BPC = 'APMBPC';

export const SIGLA_SERVICO_AUXILIO_INCLUSAO_GERAL = 'AINCLUSAO';
export const SIGLA_SERVICO_AUXILIO_INCLUSAO_CADUNICO = 'AUXINCLUS';

export const SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE = 'CONCBI';
export const SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE = 'PPBI';
export const SIGLA_SSERVICO_PERICIA_PRESENCIAL_POR_NAO_CONFIRMACAO_DOCUMENTACAO_MEDICA = 'ACONFDOC';
export const SIGLA_SERVICO_REVISAR_BENEFICIO_POR_INCAPACIDADE = 'REVBINC';

//TODO sigla temporaria ainda sem cadastro do serviço para revisão do novo beneficio por incapacidade
export const SIGLA_SERVICO_REVISAO_BENEFICIO_INCAPACIDADE = 'TRECBI';
export const SIGLA_CAMPO_ADICIONAL_ACEITE_VINCULOS = 'CIENTEVINC';

export const SIGLAS_SERVICOS_BENEFICIO_INCAPACIDADE_COM_LEGADO = [
  SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE,
  SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE,
  SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO
];

export const SIGLAS_SERVICOS_PERICIAS_BENEFICIO_INCAPACIDADE = [
  SIGLA_SERVICO_AGENDAMENTO_PERICIA_INICIAL,
  SIGLA_SERVICO_AGENDAMENTO_PERICIA_PMC,
  SIGLA_SERVICO_AGENDAMENTO_PERICIA_PMRES,
  SIGLA_SERVICO_PMF_TELEPERICIA_PMF
];

export const SIGLA_SERVICO_REAVALIACAO_BPC = 'REAVDEF';
export const SIGLA_SERVICO_PMF_REVISAO_BPC = "AREAVBPC";
export const SIGLA_SERVICO_AVALIACAO_SOCIAL_REAVALIACAO_BPC_PRIORITARIO = "AVALSOCRP";
export const SIGLA_SERVICO_AVALIACAO_SOCIAL_REAVALIACAO_BPC_REMOTA_PRIORITARIO = "AVALSOCRAP";
export const SIGLA_SERVICO_AVALIACAO_SOCIAL_REAVALIACAO_BPC = "BSASRDFPDS";
export const SIGLA_SERVICO_AVALIACAO_SOCIAL_REAVALIACAO_BPC_REMOTA = "BSASRDFPRE";
export const SIGLAS_SERVICOS_AVALIACAO_SOCIAL_REAVALIACAO_BPC = [
  SIGLA_SERVICO_AVALIACAO_SOCIAL_REAVALIACAO_BPC,
  SIGLA_SERVICO_AVALIACAO_SOCIAL_REAVALIACAO_BPC_REMOTA,
  SIGLA_SERVICO_AVALIACAO_SOCIAL_REAVALIACAO_BPC_PRIORITARIO,
  SIGLA_SERVICO_AVALIACAO_SOCIAL_REAVALIACAO_BPC_REMOTA_PRIORITARIO
]

export const SIGLA_CAMPO_ADICIONAL_ATESTADO_MEDICO = 'PATESTMED';
export const SIGLA_CAMPO_ADICIONAL_NUMERO_BENEFICIO = 'NB';
export const SIGLA_CAMPO_ADICIONAL_ESPECIE_BENEFICIO = 'ESPBEN';
export const SIGLA_CAMPO_ADICIONAL_UNIDADE_MANUTENCAO = 'APSMANUT';
export const SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO = 'TIPOPP';
export const SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA = 'SITPRIAGEN';
export const SIGLA_CAMPO_ADICIONAL_DATA_PRIMEIRO_AGENDAMENTO_PERICIA = 'DTPRIAGEND';
export const SIGLA_CAMPO_ADICIONAL_DATA_CESSACAO_BENEFICIO = 'DCB';
export const SIGLA_CAMPO_ADICIONAL_NUMERO_BENEFICIO_RESTABELECIDO = 'NBRES';
export const SIGLA_CAMPO_ADICIONAL_HOUVE_ACIDENTE_DE_TRABALHO = 'ACIDENTETB';
export const SIGLA_CAMPO_ADICIONAL_APS_VAGA_LONGA = 'APSVAGDIST';

export const SIGLAS_SERVICOS_PERICIAS_BPC = [
  SIGLA_SERVICO_PMF_BPC,
  SIGLA_SERVICO_PMF_TELEMEDICINA_BPC,
  SIGLA_SERVICO_PMF_REVISAO_BPC,
  SIGLA_SERVICO_PMF_REAVALIACAO_TELEPERICIA_B87 
]

export function isServicoPericiaInicial(sigla) {
  return SIGLA_SERVICO_PERICIA_INICIAL === sigla;
}

export function isServicoPericiaInicialComAtestado(sigla) {
  return SIGLA_SERVICO_PERICIA_INICIAL_COM_ATESTADO === sigla;
}

export function isServicoBIComDocumentoMedico(sigla) {
  return SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO === sigla;
}

export function isServicoPericiaProrrogacao(sigla) {
  return SIGLA_SERVICO_PERICIA_PEDIDO_PRORROGACAO === sigla;
}

export function isServicoPericia(sigla) {
  return (
    isServicoPericiaInicial(sigla) || isServicoPericiaProrrogacao(sigla)
  );
}

export function isAuxilioInclusaoGeral(sigla) {
  return SIGLA_SERVICO_AUXILIO_INCLUSAO_GERAL === sigla;
}

export function isAuxilioInclusaoCadUnico(sigla) {
  return SIGLA_SERVICO_AUXILIO_INCLUSAO_CADUNICO === sigla;
}

export function isAuxilioInclusao(sigla) {
  return (
    isAuxilioInclusaoGeral(sigla) || isAuxilioInclusaoCadUnico(sigla)
  );
}

export function isServicoCTC(sigla) {
  return [
    SIGLA_SERVICO_CANCELAR_CTC,
    SIGLA_SERVICO_SOLICITAR_CTC,
    SIGLA_SERVICO_REVISAO_CTC
  ].includes(sigla);
}

export function isServicoRevisarCTC(sigla) {
  return SIGLA_SERVICO_REVISAO_CTC === sigla;
}

export function isServicoRevisarOuIncluirCTC(sigla) {
  return [
    SIGLA_SERVICO_SOLICITAR_CTC,
    SIGLA_SERVICO_REVISAO_CTC
  ].includes(sigla);
}

export function isServicoRevisarOuCancelarCTC(sigla) {
  return [
    SIGLA_SERVICO_CANCELAR_CTC,
    SIGLA_SERVICO_REVISAO_CTC
  ].includes(sigla);
}

export function isServicoAvaliacaoSocial(siglaServico) {
  return [...SIGLAS_SERVICOS_AGENDAMENTO_B87, ...SIGLAS_SERVICOS_AVALIACAO_SOCIAL_REAVALIACAO_BPC].includes(siglaServico);  
}

export function isServicoPMFBPC(servico) {
  return servico && servico.sigla === SIGLA_SERVICO_PMF_BPC;
}

export function isServicoConcessaoBeneficioIncapacidade(sigla) {
  return SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE === sigla;
}

export function isServicoProrrogacaoBeneficioIncapacidade(sigla) {
  return SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE === sigla;
}

export function isServicoRevisaoBeneficioIncapacidade(sigla) {
  return SIGLA_SERVICO_REVISAO_BENEFICIO_INCAPACIDADE === sigla;
}

export function isServicoBeneficioIncapacidade(sigla) {
  return [
    SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE,
    SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE,
    SIGLA_SERVICO_REVISAO_BENEFICIO_INCAPACIDADE,
    SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO
  ].includes(sigla);
}

export function isServicoReavaliacaoBPC(sigla) {
  return SIGLA_SERVICO_REAVALIACAO_BPC === sigla;
}

export function isCampoAdicionalAceiteVinculos(sigla) {
  return SIGLA_CAMPO_ADICIONAL_ACEITE_VINCULOS === sigla;
}

export function isAgendamentoPericiaBIOuBPC(sigla) {
  const siglasPericia = [...SIGLAS_SERVICOS_PERICIAS_BPC, ...SIGLAS_SERVICOS_PERICIAS_BENEFICIO_INCAPACIDADE];
  return siglasPericia.includes(sigla);
}

export const LISTA_SIGLAS_SERVICOS_LEGADOS = [SIGLA_SSERVICO_PERICIA_PRESENCIAL_POR_NAO_CONFIRMACAO_DOCUMENTACAO_MEDICA, SIGLA_SERVICO_REVISAR_BENEFICIO_POR_INCAPACIDADE];

export const SIGLAS_FILTRO_CARD_REQUERIMENTO_BI = [
  SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE,
  SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE,
  SIGLA_SERVICO_REVISAO_BENEFICIO_INCAPACIDADE,
  SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO
]